import React from "react";
import { Habit, Day } from "../types";
import { calculateWeeklyStreak, hasWeeklyBonus } from "../utils/habitUtils";

interface StreakIndicatorProps {
  habit: Habit;
  days: Day[];
  selectedDay: string;
  isActive: boolean;
}

export const StreakIndicator: React.FC<StreakIndicatorProps> = ({
  habit,
  days,
  selectedDay,
  isActive,
}) => {
  if (!habit.streakEnabled) return null;

  const streakResult = calculateWeeklyStreak(habit.id, selectedDay, days, habit.allowSkip || false, isActive);
  const { count: displayStreak, isPotential, isGrayedOut } = streakResult;
  const wouldBeWeekly = displayStreak >= 7;

  return (
    <sup style={{
      fontSize: "0.7em",
      fontWeight: "bold",
      marginLeft: "3px",
      display: "inline-flex",
      alignItems: "center",
      height: "14px",
    }}>
      <span style={{
        backgroundColor: (!isPotential && hasWeeklyBonus(displayStreak)) || (isPotential && wouldBeWeekly && !isGrayedOut) ? "#ffc107" : "transparent",
        aspectRatio: "1/1",
        color: !isPotential
          ? "#fff"
          : isGrayedOut
            ? "#999"
            : wouldBeWeekly ? "#000" : "#888",
        padding: "4px 4px",
        borderRadius: "8px",
        opacity: isPotential ? (isGrayedOut ? 0.5 : 0.8) : 1,
        fontVariantNumeric: "tabular-nums",
        minWidth: "2ch",
        textAlign: "center"
      }}>
        {displayStreak}
      </span>
    </sup>
  );
};